<div>
    <form [formGroup]="addressFormGroup">
        <!-- Phone Number -->
        <div class="row">
            <mat-form-field appearance="outline" class="w-100" color="accent">
                <mat-label>Phone Number</mat-label>
                <input
                    class="p-0"
                    matInput
                    placeholder="XXX XXX XXXX"
                    type="tel"
                    autocomplete="tel-national"
                    formControlName="phoneNumber"
                    required
                    maxlength="10" />
                <mat-error>
                    {{ getHelperText("phoneNumber") }}
                </mat-error>
            </mat-form-field>
        </div>
        <!-- Country -->
        <div class="row">
            <mat-form-field appearance="outline" class="w-100" color="accent">
                <mat-label>Country</mat-label>
                <mat-select
                    placeholder="Select..."
                    required
                    formControlName="country"
                    (selectionChange)="onCountrySelected($event)">
                    <mat-option
                        *ngFor="let country of countries"
                        [value]="country.value">
                        {{ country.viewValue }}
                    </mat-option>
                </mat-select>
                <mat-error>
                    {{ getHelperText("country") }}
                </mat-error>
            </mat-form-field>
        </div>
        <!-- Street Address -->
        <div class="row">
            <mat-form-field appearance="outline" class="w-100" color="accent">
                <mat-label>Address</mat-label>
                <input
                    matInput
                    placeholder="Street address or P.O Box"
                    autocomplete="address-line1"
                    formControlName="address1"
                    required />
                <mat-error>
                    {{ getHelperText("address1") }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field appearance="outline" class="w-100" color="accent">
                <input
                    matInput
                    placeholder="Apt, Suite, Unit, Building"
                    autocomplete="address-line2"
                    formControlName="address2" />
                <mat-error>
                    {{ getHelperText("address2") }}
                </mat-error>
            </mat-form-field>
        </div>
        <!-- City -->
        <div class="row">
            <div class="col-sm-5">
                <mat-form-field
                    appearance="outline"
                    class="w-100"
                    color="accent">
                    <mat-label>City</mat-label>
                    <input
                        matInput
                        placeholder="Enter City…"
                        autocomplete="address-level2"
                        formControlName="city"
                        required
                        fullNameDirective />
                    <mat-error>
                        {{ getHelperText("city") }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-sm-5">
                <mat-form-field
                    appearance="outline"
                    class="w-100"
                    color="accent">
                    <mat-label>
                        {{ provinceLabel }}
                    </mat-label>
                    <mat-select
                        placeholder="Select..."
                        formControlName="province"
                        required>
                        <mat-option
                            *ngFor="let province of sortedProvincesCanada"
                            [value]="province.value">
                            {{ province.viewValue }}
                        </mat-option>
                    </mat-select>
                    <mat-error>
                        {{ getHelperText("province") }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <mat-form-field
                class="w-100"
                color="accent"
                appearance="outline"
                *ngIf="selectedCountry === allCountries.Ca">
                <mat-label>{{ postalCodeLabel }}</mat-label>
                <input
                    matInput
                    placeholder="A1A1A1"
                    autocomplete="postal-code"
                    maxlength="10"
                    formControlName="postalCode"
                    required
                    postalCode
                    id="input-text-style-uppercase" />
                <mat-error>
                    {{ getHelperText("postalCode") }}
                </mat-error>
            </mat-form-field>
            <mat-form-field
                color="accent"
                appearance="outline"
                *ngIf="selectedCountry === allCountries.Us">
                <mat-label>{{ postalCodeLabel }}</mat-label>
                <input
                    matInput
                    placeholder="12345"
                    autocomplete="postal-code"
                    maxlength="10"
                    formControlName="postalCode"
                    required
                    postalCode
                    id="input-text-style-uppercase" />
                <mat-error>
                    {{ getHelperText("postalCode") }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field color="accent" appearance="outline" class="w-100">
                <mat-label>Buzzer</mat-label>
                <input
                    matInput
                    placeholder="XXXXX"
                    maxlength="10"
                    formControlName="buzzer"
                    id="input-text-style-uppercase" />
                <mat-error>
                    {{ getHelperText("buzzer") }}
                </mat-error>
            </mat-form-field>
        </div>
    </form>
</div>
